import * as accounts from "./modules/accounts";
import * as routing from "./modules/routing";

export const modules = { accounts, routing };

export const state = {};
